module.exports = __webpack_public_path__ + "img/pebble-1.f0e54534.jpeg";